import React, { useRef, useState } from "react";

import { Button, Carousel, Skeleton, Tooltip } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { CiImageOff } from "react-icons/ci";

/** Үлдэгдлийн түвшний өнгө: дууссан → улаан, цөөрсөн → улбар шар */
const OUT_OF_STOCK_COLOR = "#F5222D";
const LOW_STOCK_COLOR = "#FA8C16";
const NORMAL_STOCK_COLOR = "#2FA1D9";

/** Үүнээс доош үлдэгдлийг "цөөрсөн" гэж үзнэ */
const LOW_STOCK_THRESHOLD = 10;

const stockBadge = (stock) => {
  if (stock === 0) return { label: "Дууссан", color: OUT_OF_STOCK_COLOR };
  if (stock <= LOW_STOCK_THRESHOLD) return { label: `${stock}ш`, color: LOW_STOCK_COLOR };
  return { label: `${stock}ш`, color: NORMAL_STOCK_COLOR };
};

const carouselSettings = {
  slidesPerRow: 6,
  rows: 1,
  responsive: [
    { breakpoint: 1560, settings: { slidesPerRow: 6 } },
    { breakpoint: 1350, settings: { slidesPerRow: 4 } },
    { breakpoint: 1150, settings: { slidesPerRow: 3 } },
    { breakpoint: 990, settings: { slidesPerRow: 4 } },
    { breakpoint: 840, settings: { slidesPerRow: 3 } },
    { breakpoint: 640, settings: { slidesPerRow: 2 } },
    { breakpoint: 400, settings: { slidesPerRow: 1 } },
  ],
};

const ProductTile = ({ productName, productImage, stock }) => {
  const [imageFailed, setImageFailed] = useState(false);
  const { label, color } = stockBadge(stock);

  return (
    <div className="product_container">
      <div className="product_img_container">
        <div className="product_status" style={{ background: color }}>
          {label}
        </div>
        {imageFailed || !productImage ? (
          // Зураг ачаалагдахгүй бол эвдэрсэн дүрс биш, ойлгомжтой орлуулга
          <div className="product_img product_img_fallback">
            <CiImageOff size={28} />
          </div>
        ) : (
          <img
            className="product_img"
            src={productImage}
            alt={productName}
            loading="lazy"
            onError={() => setImageFailed(true)}
          />
        )}
      </div>
      <Tooltip title={productName}>
        <div className="product_name">{productName}</div>
      </Tooltip>
    </div>
  );
};

const Products = ({ products, loading }) => {
  const ref = useRef(null);

  const prev = () => ref.current?.prev();
  const next = () => ref.current?.next();

  return (
    <div className="db_item_container carousel_container">
      <div className="db_item_container_header">
        <h3>Бага үлдэгдэлтэй болон дууссан бараа</h3>
      </div>

      <div className="db_item_container_body">
        {loading ? (
          <Skeleton active paragraph={{ rows: 4 }} />
        ) : (
          <>
            <Button
              className="carousel_btn carousel_prev_btn"
              shape="circle"
              icon={<LeftOutlined />}
              onClick={prev}
              aria-label="Өмнөх"
            />
            <Button
              className="carousel_btn carousel_next_btn"
              shape="circle"
              icon={<RightOutlined />}
              onClick={next}
              aria-label="Дараах"
            />
            <Carousel ref={ref} dots={false} {...carouselSettings}>
              {/*
                Барааны нэр давхардаж болдог (жишээ нь ижил нэртэй өөр хэмжээ)
                тул индексийг түлхүүрт оруулж React-ийн давхардлаас сэргийлнэ
              */}
              {products?.map((product, index) => (
                <div key={`${product.productName}-${index}`}>
                  <ProductTile {...product} />
                </div>
              ))}
            </Carousel>
          </>
        )}
      </div>
    </div>
  );
};

export default Products;
